<h1 mat-dialog-title>Płatność Ekspresowa jest niedostępna dla {{disabledExpressPaymentLiabilities.length > 1 ? 'faktur' : 'faktury'}}</h1>
<p>
  Nie możemy zrealizować płatności ekspresowej, ponieważ {{disabledExpressPaymentLiabilities.length > 1 ? 'niektóre z opłat są realizowane' : 'jedna z opłat jest realizowana'}}
  na konto Zakładu Ubezpieczeń Społecznych bądź Urzędu Skarbowego.
</p>
<p><b>Usuń {{disabledExpressPaymentLiabilities.length > 1 ? 'je' : 'ją'}} z koszyka, lub wyłącz opcje płatności ekspresowej.</b></p>
<br />
<ng-container
  *ngFor='let liability of disabledExpressPaymentLiabilities; let last = last; let i = index'
>
  <h3>Tytuł: {{ liability.title }}</h3>
  <div fxFlex="row" fxLayoutAlign="start start" fxLayoutGap="8px">
    <div>Kwota:</div>
    <div>{{ liability.amountToPay | number: '1.2-2':'pl' }} zł</div>
  </div>
  <div fxFlex="row" fxLayoutAlign="start start" fxLayoutGap="8px">
    <div>Dostawca:</div>
    <div>{{ liability.billerName }}</div>
  </div>
  <div fxFlex="row" fxLayoutAlign="start start" fxLayoutGap="8px">
    <div>Płatna do:</div>
    <div>{{ liability.paymentDue | date: defaultPattern }}</div>
  </div>
</ng-container>

<mat-dialog-actions align='start'>
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
